import React from "react";

import { ConfirmContext } from "src/features/confirm/ConfirmContext";
import { ConfirmOptions } from "src/features/confirm/types";

export function useConfirm(): (options: ConfirmOptions) => Promise<unknown> {
	return React.useContext(ConfirmContext);
}
